export default "__VITE_ASSET__BlqT3r$x__"